import PageHero from "../components/PageHero.jsx";
import CTA from "../components/CTA.jsx";

const focusAreas = [
  "Freeze-dried fruits",
  "Vegetables",
  "Herbs",
  "Tea cuts",
  "Botanicals",
  "Functional ingredients",
  "Wellness-focused applications"
];

export default function About() {
  return (
    <>
      <PageHero
        eyebrow="About us"
        title="We got curious about food preservation. Then things became much bigger."
        text="ContiGO Freeze Foods is being built around the idea that food preservation can be smarter, cleaner and more globally connected."
        image="/images/premium-herbal-tea.jpg"
      />

      <section className="content-band">
        <div className="section-inner editorial-grid">
          <div>
            <p className="eyebrow">About content</p>
            <h2>A trusted sourcing and freeze-dried ingredient ecosystem for global markets.</h2>
          </div>
          <div className="copy-stack">
            <p>
              What started as an exploration into freeze-dried foods slowly opened up a much bigger
              world around ingredient ecosystems, shelf-life innovation, botanicals, wellness products
              and functional foods.
            </p>
            <p>
              With India’s agricultural diversity as the foundation, our long-term vision is to build
              a trusted sourcing and freeze-dried ingredient ecosystem for global markets.
            </p>
          </div>
        </div>
      </section>

      <section className="content-band muted-band">
        <div className="section-inner">
          <p className="eyebrow">We are focused on exploring and building across</p>
          <div className="signal-grid">
            {focusAreas.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}
